import { Layout } from "@components/Layout";
import { AppErrorBoundary } from "@components/ErrorBoundary";
import { ROUTER_PATHS } from "@constants/index";
import { AppConfig } from "@pages/AppConfig";
import { Login } from "@pages/Login";
import { PageNotFound } from "@pages/PageNotFound";
import { Main } from "@pages/Main";
import { Profile } from "@pages/Profile";
import { useUserData } from "@/hooks/queries";
import { Navigate, Route, Routes } from "react-router-dom";

export const AppRouter = () => {
  const { data: userData } = useUserData();
  const isAdmin = userData?.isAdmin;
  const isUserData = !!userData;
  return (
    <Routes>
      <Route path={ROUTER_PATHS.main} element={<Layout />}>
        <Route index element={<AppErrorBoundary><Main /></AppErrorBoundary>} />
        <Route path={`${ROUTER_PATHS.profile}/:id`} element={<AppErrorBoundary><Profile /></AppErrorBoundary>} />
        <Route path={ROUTER_PATHS.login} element={<Login />} />
        {isUserData && !isAdmin &&
          <Route
            path={`${ROUTER_PATHS.profile}/${ROUTER_PATHS.newProfile}`}
            element={<Navigate to={ROUTER_PATHS.main} />}
          />
        }
        {isAdmin && (
          <Route
            path={ROUTER_PATHS.appConfig}
            element={<AppErrorBoundary><AppConfig /></AppErrorBoundary>}
          />
        )}
        <Route
          path={ROUTER_PATHS.signedOut}
          element={<Navigate to={ROUTER_PATHS.main} replace />}
        />
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};
